var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDragAndDrop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9561_8815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.042 41.25C13.1826 41.25 10.4404 40.1635 8.4185 38.2295C6.39662 36.2956 5.26074 33.6725 5.26074 30.9375C5.26074 28.2025 6.39662 25.5794 8.4185 23.6455C10.4404 21.7115 13.1826 20.625 16.042 20.625C16.7173 17.6165 18.6929 14.9726 21.5342 13.275C22.941 12.4344 24.5181 11.8515 26.1752 11.5594C27.8324 11.2674 29.5373 11.272 31.1925 11.5729C32.8477 11.8739 34.4208 12.4653 35.822 13.3134C37.2233 14.1615 38.4252 15.2497 39.3592 16.5159C40.2931 17.782 40.9408 19.2014 41.2653 20.6928C41.5898 22.1843 41.5847 23.7187 41.2503 25.2083H43.542C45.6693 25.2083 47.7094 26.0534 49.2136 27.5576C50.7178 29.0618 51.5628 31.1019 51.5628 33.2292C51.5628 35.3564 50.7178 37.3966 49.2136 38.9008C47.7094 40.405 45.6693 41.25 43.542 41.25H41.2503",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.625 34.375L27.5 27.5L34.375 34.375",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 27.5V48.125",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9561_8815"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDragAndDrop);
export default __webpack_public_path__ + "static/media/icon_drag_and_drop.f43ef5dc6225b48c7f340d6483ff0c77.svg";
export { ForwardRef as ReactComponent };